import * as angular from 'angular';

class LngLocationDetailsIdentifierCtrl implements ng.IController {
    public storageLocation: StorageLocationDto;
    public isEditMode: boolean;
    public isCreateMode: boolean;
    public isEditable = this.isCreateMode || this.isEditMode;
    public identifierExpanded: boolean = true;

    constructor() {}

    $onInit() {}
}

angular.module('app').component('pkpLngLocationDetailsIdentifier', {
    controller: LngLocationDetailsIdentifierCtrl,
    template:
        require('app/lng-location/lng-location-details-identifier.component.html'),
    bindings: {
        form: '<',
        storageLocation: '=',
        isEditMode: '<',
        isCreateMode: '<'
    }
});
